export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/opt/build/repo/layouts/empty.vue").then(m => m.default || m)
}